// extracted by css-extract-rspack-plugin
export default {"root":"S_G252","value":"U7jEkS","label":"kc2Ilo"};